import React from 'react'

function HomeCenBlogs() {
  return (
    <div>
      Blogs
    </div>
  )
}

export default HomeCenBlogs
